<template>
  <div class="input-group">
    <span class="input-group-text">
      <font-awesome-icon :icon="['far', 'magnifying-glass']" />
    </span>
    <input
      class="form-control"
      id="search"
      :placeholder="$t('settings.search_placeholder')"
      type="text"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <button
      v-if="modelValue"
      class="btn btn-secondary"
      type="button"
      :aria-label="$t('settings.clear_search')"
      @click="$emit('update:modelValue', '')"
    >
      <font-awesome-icon
        :icon="['far', 'xmark']"
        class="text-white"
      />
    </button>
  </div>
</template>

<script>
  export default {
    name: "ToolSearchBar",
    props: {
      modelValue: {
        type: String,
        default: "",
      },
    },
    emits: ["update:modelValue"],
  };
</script>
